{
  "langs": ["en"]
}
